import React,{useEffect,useMemo,useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import {apiRequest,getEntityId,unwrapCollection} from '../../api/client';
import SafeIcon from '../../common/SafeIcon';

const {FiTrendingUp}=FiIcons;

function AnalyticsPage() {
  const [data,setData]=useState({progress: [],cards: []});
  const [error,setError]=useState('');

  useEffect(()=> {
    let active=true;

    Promise.all([
      apiRequest('/progress'),
      apiRequest('/flashcards',{auth: false})
    ])
      .then(([progressPayload,cardPayload])=> {
        if (!active) {
          return;
        }

        setData({
          progress: unwrapCollection(progressPayload,['progress','items','results']),
          cards: unwrapCollection(cardPayload,['flashcards','items','results'])
        });
      })
      .catch((requestError)=> {
        if (active) {
          setError(requestError.message);
        }
      });

    return ()=> {
      active=false;
    };
  },[]);

  const learningWords=useMemo(()=> {
    const learningCounts=new Map();

    data.progress.forEach((item)=> {
      if (item.status!=='learning') {
        return;
      }

      const cardId=getEntityId(item) || item.flashcard_id;
      learningCounts.set(
        cardId,
        (learningCounts.get(cardId) || 0)+1
      );
    });

    return data.cards
      .map((card)=> ({
        ...card,
        count: learningCounts.get(getEntityId(card)) || 0
      }))
      .filter((card)=> card.count>0)
      .sort((a,b)=> b.count-a.count);
  },[data]);

  const max=learningWords[0]?.count || 1;

  return (
    <section>
      <header className="page-heading">
        <div>
          <span className="eyebrow">Learning signals</span>
          <h1>Analytics</h1>
          <p>Words currently marked “still learning” across student progress.</p>
        </div>
      </header>

      {error && <div className="error-banner">{error}</div>}

      <div className="analytics-panel">
        <div className="analytics-title">
          <span><SafeIcon icon={FiTrendingUp} /></span>
          <div>
            <h2>Most challenging words</h2>
            <p>Based on current learning status.</p>
          </div>
        </div>

        {learningWords.length ? (
          learningWords.slice(0,10).map((word)=> (
            <div className="bar-row" key={getEntityId(word)}>
              <div>
                <b>{word.front_text}</b>
                <span>{word.back_text}</span>
              </div>
              <div className="bar-track">
                <span style={{width: `${(word.count/max)*100}%`}} />
              </div>
              <strong>{word.count}</strong>
            </div>
          ))
        ) : (
          <div className="empty-inline">
            No words are currently marked as still learning.
          </div>
        )}
      </div>
    </section>
  );
}

export default AnalyticsPage;